let getAccessTokenSilentlyInternal: () => Promise<string>
let logoutInternal: () => void = () => {}

export function getAccessTokenSilently() {
  return getAccessTokenSilentlyInternal?.()
}

export function setAccessTokenSilently(func: () => Promise<string>) {
  getAccessTokenSilentlyInternal = func
}

export function logout() {
  return logoutInternal()
}

export function setLogout(func: () => void) {
  logoutInternal = func
}
